import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const MaskLines = ({ lines, delay = 0, className = "" }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em]">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1.1, delay: delay + i * 0.13, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const FadeUp = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <p className={`font-mono flex items-center gap-2 text-xs uppercase tracking-[0.22em] ${dark ? "text-[#7fb2ff]" : "text-[#0D6EFD]"}`}>
    <span className="h-px w-8 bg-current" />
    {children}
  </p>
);

export const Placeholder = ({ children, dark = false, testId }) => (
  <span data-testid={testId} className={`font-mono inline-block rounded-md border border-dashed px-2 py-0.5 text-[11px] uppercase tracking-wider ${dark ? "border-white/30 text-slate-300" : "border-slate-400 text-slate-600"}`}>
    {children}
  </span>
);
